const contractsRoutes = [
  {
    path: "/contracts",
    name: "contracts",
    component: () =>
      import(
        /* webpackChunkName: "contracts" */ "../components/contracts/ContractList.vue"
      ),
  },
  {
    path: "/contracts/new",
    name: "contract-new",
    component: () =>
      import(
        /* webpackChunkName: "contracts" */ "../components/contracts/ContractDetail.vue"
      ),
  },
  {
    path: "/contracts/:id",
    name: "contract-detail",
    component: () =>
      import(
        /* webpackChunkName: "contracts" */ "../components/contracts/ContractDetail.vue"
      ),
  },
];

export default contractsRoutes;
